var _g, _g2, _g3, _g4, _g5, _g6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmallBlue = function SvgSmallBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_812",
    "data-name": "Group 812",
    width: 69,
    height: 28.745,
    viewBox: "0 0 69 28.745",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806",
    transform: "translate(7.32 16.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M739.459,124.038a6.177,6.177,0,0,0-11.318,0c-.058.13-.1.269-.145.4s-.086.267-.125.4a5.788,5.788,0,0,0,.468,4.536c.073.14.142.283.225.415s.189.28.291.418a6.133,6.133,0,0,0,9.879.012c.1-.132.2-.262.286-.4s.147-.268.219-.4a5.794,5.794,0,0,0,.489-4.576c-.039-.136-.078-.271-.126-.4S739.516,124.168,739.459,124.038Zm-2.881,5.382a4.081,4.081,0,0,1-1.206.805,4,4,0,0,1-3.145,0,3.938,3.938,0,0,1-.718-.4,3.976,3.976,0,0,1-1.349-4.978,3.886,3.886,0,0,1,.219-.4,4.127,4.127,0,0,1,.287-.4,3.97,3.97,0,0,1,6.265,0,4.343,4.343,0,0,1,.287.4,3.855,3.855,0,0,1,.218.4,3.959,3.959,0,0,1-.859,4.576Z",
    transform: "translate(-727.609 -120.337)",
    fill: "#06016c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(19.872 20.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M768.33,125.927a6.921,6.921,0,0,1,.213-1.683H738.91a6.868,6.868,0,0,1-.421,4.576h30.475A6.952,6.952,0,0,1,768.33,125.927Z",
    transform: "translate(-738.489 -124.244)",
    fill: "#06016c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(50.518 16.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M776.9,124.038a6.177,6.177,0,0,0-11.318,0c-.058.13-.1.269-.144.4s-.087.267-.125.4a5.779,5.779,0,0,0,.489,4.576c.072.135.137.275.219.4s.187.27.286.4a6.131,6.131,0,0,0,9.866,0c.1-.133.2-.263.286-.4s.148-.269.219-.4a5.788,5.788,0,0,0,.49-4.576c-.039-.136-.078-.271-.126-.4S776.959,124.168,776.9,124.038Zm-2.882,5.382a4,4,0,0,1-6.414-4.576,3.852,3.852,0,0,1,.219-.4,4.026,4.026,0,0,1,6.837,0,3.853,3.853,0,0,1,.219.4,3.958,3.958,0,0,1-.861,4.576Z",
    transform: "translate(-765.052 -120.337)",
    fill: "#06016c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(63.07 20.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M776.98,128.821a4.888,4.888,0,0,0,4.864-4.577h-5.492a6.859,6.859,0,0,1-.42,4.577Z",
    transform: "translate(-775.932 -124.244)",
    fill: "#06016c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810",
    transform: "translate(1.087 20.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M722.206,124.244a8.832,8.832,0,0,0,5.978,4.4,6.891,6.891,0,0,1-.337-4.4Z",
    transform: "translate(-722.206 -124.244)",
    fill: "#06016c"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M728.245,126.218a6.984,6.984,0,0,1,13.06,0h30.138a6.984,6.984,0,0,1,13.06,0h5.762a9.287,9.287,0,0,0-1.773-5.164h-4.476a.4.4,0,1,1,0-.805h3.808a9.207,9.207,0,0,0-5.6-2.93l-8.211-1.082a4.156,4.156,0,0,1-1.778-.669h0l-6.915-4.61a28.525,28.525,0,0,0-15.871-4.805H737.27a10.955,10.955,0,0,0-7.958,3.446l-6.342,6.765a6.284,6.284,0,0,0-1.706,4.315v2.116a8.745,8.745,0,0,0,.693,3.424Zm9.223-17.512H741.7l.02.147,1.1,7.767-11.611-.591a.451.451,0,0,1-.367-.678l2.487-4.263A4.812,4.812,0,0,1,737.468,108.706Zm6.615,7.779-1.1-7.779h6.443a26.7,26.7,0,0,1,14.757,4.434l6.273,4.143a.384.384,0,0,1,.159.457.388.388,0,0,1-.38.275h-.021l-26.1-1.329Zm3.464,3.826h-2.086a.4.4,0,0,1,0-.806h2.086a.4.4,0,0,1,0,.806ZM724.071,116.7l7.145-7.481a.4.4,0,0,1,.583.556l-7.145,7.481a.4.4,0,0,1-.291.125l-.279-.112A.4.4,0,0,1,724.071,116.7Z",
    transform: "translate(-721.264 -106.152)",
    fill: "#06016c"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmallBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smallBlue.552506c7.svg";
export { ForwardRef as ReactComponent };